import bonfireImage from "../Images/CampingBonfire.png";

const stats = [
  { name: "Happy customers", value: "10K+" },
  { name: "Customer rating", value: "4.7★" },
  { name: "Available year-round", value: "365 days" },
  { name: "Group discounts", value: "20%+" },
  { name: "Campers hosted", value: "25K+" },
  { name: "Trek experiences", value: "250+" },
  { name: "Stay options", value: "30+" },
  { name: "Guest support", value: "A+" },
];

export default function WhyWe() {
  return (
    <section className="relative isolate overflow-hidden bg-emerald-950 py-12 text-white sm:py-16">
      <img
        alt=""
        src={bonfireImage}
        className="absolute inset-0 -z-20 h-full w-full object-cover opacity-25"
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-emerald-950/95 via-emerald-950/90 to-stone-900/90" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-amber-200">
            Made for the outdoors
          </p>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Your next adventure, thoughtfully planned
          </h2>
          <p className="mt-4 text-base leading-7 text-emerald-50/90 sm:text-lg">
            From lakeside camping to the trails of the Sahyadri, we help bring
            people together for memorable time outdoors—with friendly support
            from planning to check-in.
          </p>
        </div>
        <dl className="mt-9 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
          {stats.map((stat) => (
            <div
              key={stat.name}
              className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur-sm sm:p-5"
            >
              <dd className="text-2xl font-bold tracking-tight text-amber-200 sm:text-3xl">
                {stat.value}
              </dd>
              <dt className="mt-1 text-sm leading-5 text-emerald-50/90">
                {stat.name}
              </dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
